<div class="advertisers layout-spacing">
    <!-- The to be projected content into the subnavbar -->
    <ng-template #subNavBarContent>
        <ntv-button
            color="custom"
            customColor="#8DCB2C"
            size="xl"
            rounded="md"
            (click)="onCreateAdvertiser()">
            <span class="text-white">
                <div class="main-btn text-white">
                    <span> Create Advertiser</span>

                    <svg width="14" height="14">
                        <use [attr.href]="spritePath + '#' + icons['ads']"></use>
                    </svg>
                </div>
            </span>
        </ntv-button>
    </ng-template>

    <div class="advertisers__stats">
        @for (advertiserStats of statsData(); track advertiserStats.title + $index) {
            <app-stats-card
                [statsData]="advertiserStats"
                [hasTotal]="true"
                width="100%"></app-stats-card>
        }
    </div>
    <div class="advertisers__table">
        <div class="advertisers__table-header">
            <app-table-toolbar
                [placeholder]="'Search Host Name, Address, City, Postal Code, DMA Name or #Tag '"
                [buttons]="toolbarButtons()"
                (actionClick)="onToolbarAction($event)">
                <app-dropdown
                    [options]="timezoneConfig().options"
                    leftActions
                    [placeholder]="timezoneConfig().placeholder"
                    (selectionChange)="onTimezoneChange($event)" />

                <!-- <ntv-date-range-picker leftActions variant="single"></ntv-date-range-picker> -->
            </app-table-toolbar>
        </div>
        <div class="advertisers__table-body">
            <div class="advertisers__content-table main-table-container">
                <app-table
                    [columns]="advertisersColumns"
                    [data]="advertisersData"
                    [tableTitle]="'Advertisers'"
                    [tableHeight]="'780px'"
                    [hasCheckBox]="true"
                    [paddingY]="'14px'"
                    (actionClick)="onActionClick($event)"
                    (cellClick)="onCellClick($event)"
                    (selectionChange)="onSelectionChange($event)">
                </app-table>
            </div>
        </div>
    </div>

    <!-- Delete Confirmation Modal -->
    @if (showDeleteConfirmationModal()) {
        <app-confirmation-modal
            [isVisible]="showDeleteConfirmationModal()"
            [showCancelButton]="true"
            size="medium"
            [type]="'warning'"
            [title]="'Confirm Deleting Advertiser'"
            [message]="
                selectedRows().length > 1
                    ? 'Are you sure you want to delete these advertisers?'
                    : 'Are you sure you want to delete this advertiser?'
            "
            [confirmText]="'Delete'"
            cancelText="Cancel"
            (confirm)="onConfirmDelete()"
            (cancel)="closeModal()"
            (modalClose)="closeModal()" />
    }
</div>
